import { Link } from 'react-router-dom';
import './HeroSection.css';

export default function HeroSection() {
  return (
    <section className="hero-section">
      {/* Background decorations */}
      <div className="hero-bg">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      <div className="hero-content">
        {/* Mascot */}
        <div className="hero-mascot">
          <div className="mascot-container">
            <span className="mascot-emoji">🦀</span>
            <div className="mascot-sparkles">
              <span className="sparkle">✨</span>
              <span className="sparkle">💫</span>
              <span className="sparkle">⭐</span>
            </div>
          </div>
        </div>

        {/* Text content */}
        <div className="hero-text">
          <h1 className="hero-title">
            Your Personal <span className="highlight">OpenClaw</span> in the Cloud
          </h1>
          <p className="hero-subtitle">
            Deploy in 2 minutes. No servers. No Docker. Just AI magic.
          </p>
          <div className="hero-cta">
            <Link to="/login" className="btn btn-primary btn-large">
              Get Started
              <span className="btn-icon">→</span>
            </Link>
            <a href="#features" className="btn btn-secondary btn-large">
              Learn More
            </a>
          </div>
          <div className="hero-social-proof">
            <div className="proof-avatars">
              <span className="avatar">👤</span>
              <span className="avatar">👤</span>
              <span className="avatar">👤</span>
            </div>
            <span className="proof-text">Join <strong>500+</strong> users building with OpenClaw</span>
          </div>
        </div>
      </div>
    </section>
  );
}
